// Basic
import PropTypes from 'prop-types';
// Components
import Icon from '../icon/Icon';
import { Button } from '../../ui/button';
// Common
import ICONS from '@/common-utils/enums/icons';
import RouteUrls from '@/app/root/enums/RouteUrls';
import { buildUrl, replaceParameters } from '@/common-utils/functions/restUtils';
import useSessionStore from '@/app/store/session';
import hasRequiredPermissions from '@/common-utils/functions/hasRequiredPermissions';

/**
 * @param root0
 * @param root0.pathParams
 * @param root0.baseUrl
 * @param root0.urlParams
 * @param root0.requiredPermissions
 * @param root0.hasAtLeastOnePermission
 * @returns {JSX}
 */
function DetailsButton({
    pathParams,
    baseUrl,
    urlParams,
    requiredPermissions,
    hasAtLeastOnePermission = true
}) {

    // Store
    const session = useSessionStore(s => s.session);

    // Check if the user has the required permissions
    const hasPermission = requiredPermissions?.length ? hasRequiredPermissions({
        permissions: session?.permissions,
        requiredPermissions,
        hasAtLeastOnePermission: requiredPermissions.length > 1 ? hasAtLeastOnePermission : true
    }) : true;

    // Build the URL for href using # prefix
    const url = pathParams ? `#${buildUrl(replaceParameters(baseUrl, pathParams), urlParams)}` : RouteUrls.HOME;

    return hasPermission ? (
        <Button asChild variant='ghostNoBorder' size='icon' data-cy='details-button'>
            <a href={url}><Icon icon={ICONS.DETAILS} /></a>
        </Button>
    ) : (
        <Button variant='ghostNoBorder' size='icon' data-cy='details-button' disabled icon={ICONS.DETAILS} />
    );
}

DetailsButton.propTypes = {
    pathParams: PropTypes.object,
    baseUrl: PropTypes.string,
    urlParams: PropTypes.object,
    requiredPermissions: PropTypes.arrayOf(PropTypes.string),
    hasAtLeastOnePermission: PropTypes.bool
};
export default DetailsButton;